export { default } from "./array-details-field";
